import { ArrayManipulations } from './arrayManipulations';
import { Injectable, Inject, VERSION } from '@angular/core';
import { LookupDataService } from '../http/lookupdata.service'
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { Observable, ReplaySubject, Subject, BehaviorSubject } from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import * as moment from 'moment';
import { InteractService } from '../services';
import { ClaimPaymentDO } from 'app/BaseFramework/shared/models';
import * as flat from 'flat'
import * as dict from '../../../../../node_modules/spelling/dictionaries/en_US.js'
import * as spelling from '../../../../../node_modules/spelling/'
import { MetadataService } from '../http/metadata.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import * as _ from 'lodash';

class SearchAPIMetaDataDO {
    key: any;
    keyDescription: any;
    valueInputType: any;
    lookupName: any;
    lookup: any;
    enable: any;
    isMandatory: Boolean;
}

@Injectable()
export class CommonUtilty {

    constructor(private lookupDataService: LookupDataService,
        private arrayManipulations: ArrayManipulations,
        private locationStrategy: LocationStrategy,
        public appMetadataHandler: AppMetadataHandler,
        public metadataService: MetadataService,
        public message: NzMessageService,
        private fb: FormBuilder) { }

    deepCopy(o) {
        if (o)
            return JSON.parse(JSON.stringify(o));
        else
            return null
    }

    NonUniquePush(list, item, comparisonKey) {
        if (!list) list = []
        if (this.isArrayIterable(list) && item && comparisonKey) {
            let foundIndex = list.findIndex(listItem => {
                return listItem[comparisonKey] == item[comparisonKey]
            });
            if (foundIndex > -1) {
                list.splice(foundIndex, 1, item)
            }
            else {
                list.push(item)
            }
        }
        return list
    }

    refreshPayeeList(currentPayeeList, receivedPayeeList) {
        let output = this.checkAndRemovePayeeIfRemoved(currentPayeeList, receivedPayeeList);
        output = this.checkAndAddNewPayeeIfAdded(currentPayeeList, receivedPayeeList)
        return output
    }

    checkAndAddNewPayeeIfAdded(currentPayeeList, receivedPayeeList) {
        if (this.isArrayIterable(receivedPayeeList)) {
            receivedPayeeList.forEach(receivedPayee => {
                let foundIndex = currentPayeeList.findIndex(payee => receivedPayee.clientRefGuid == payee.clientRefGuid)
                if (foundIndex == -1) {
                    currentPayeeList.push(receivedPayee)
                }
            });
        }
        return currentPayeeList
    }

    checkAndRemovePayeeIfRemoved(currentPayeeList, receivedPayeeList) {
        if (this.isArrayIterable(currentPayeeList)) {
            currentPayeeList.forEach((payee, index) => {
                let foundIndex = receivedPayeeList.findIndex(receivedPayee => receivedPayee.clientRefGuid == payee.clientRefGuid)
                if (foundIndex == -1) {
                    currentPayeeList.splice(index, 1)
                }
            });
        }
        return currentPayeeList
    }

    searchAndStitchClientDO(list, IO) {
        if (this.isArrayIterable(list)) {
            list.forEach(paymentDO => {
                if (!(paymentDO && paymentDO['clientDO'])) {
                    if (IO && IO['clientDOs'] && IO['clientDOs'].length) {
                        let clientDO = IO['clientDOs'].find(client => client['guid'] == paymentDO.clientRefGuid)
                        if (clientDO) {
                            paymentDO['clientDO'] = this.deepCopy(clientDO)
                        }
                    }
                }
            });
        }

        return list
    }

    searchAndStitchClientDOForPayer(list, IO) {
        if (IO && IO['proposalDO'])
            var clientList = IO.proposalDO ? IO.proposalDO.proposalClients : IO.caseDO.caseClients;
        if (clientList && clientList.length && clientList.length > 0)
            var payer = clientList.find(client => client.roleCd === 'PAYER')
        if (this.isArrayIterable(list)) {
            list.forEach(paymentDO => {
                if (!(paymentDO && paymentDO['clientDO'])) {
                    if (IO && IO['clientDOs'] && IO['clientDOs'].length) {
                        var clientDO: any;
                        if (payer)
                            clientDO = IO['clientDOs'].find(client => client['guid'] == payer.clientRefGuid)
                        if (clientDO) {
                            paymentDO['clientDO'] = this.deepCopy(clientDO)
                        }
                    }
                }
            });
        }

        return list
    }

    calculatePercentage(percent, total) {
        let output = Math.floor(percent / total * 100);
        if (output && total)
            return output
        else
            return 0
    }

    splitCamelCase(word) {
        var output, i, l, capRe = /[A-Z]/;
        if (typeof (word) !== "string") {
            throw new Error("The \"word\" parameter must be a string.");
        }
        output = [];
        for (i = 0, l = word.length; i < l; i += 1) {
            if (i === 0) {
                output.push(word[i].toUpperCase());
            }
            else {
                if (i > 0 && capRe.test(word[i])) {
                    output.push(" ");
                }
                output.push(word[i]);
            }
        }
        return output.join("");
    }

    applyExclusionsAndReplacements(phrase) {
        if (typeof (phrase) !== "string") {
            throw new Error("The \"word\" parameter must be a string.");
        }

        this.appMetadataHandler.splitCamelCaseReplacements.forEach(replaceItem => {
            phrase = phrase.replace(new RegExp(replaceItem.code, 'g'), replaceItem.replacement)
        })

        return phrase
    }

    splitCamelCaseAndApplyReplacements(word) {
        let phrase = this.splitCamelCase(word)
        let output = this.applyExclusionsAndReplacements(phrase)
        return output
    }

    removeItemFromListUnSorted(data, list, uniqueID) {

        let newList = list
        if (list && Array.isArray(list))
            newList = list.filter(item => item[uniqueID] != data[uniqueID])
        return newList
    }

    preventBackButton() {
        history.pushState(null, null, location.href);
        this.locationStrategy.onPopState(() => {
            //   history.pushState(null, null, location.href);
            history.go(1);
        })
    }

    extractInsuredsListOutOfSearchResults(data) {
        let output = []
        if (data && data.length > 0)
            data.map(item => {
                if (item['results'] && typeof item['results'] == typeof [])
                    output.push(...item['results'])
            })
        output = this.arrayManipulations.getUniqueElements(output, 'clientNum');
        return output;
    }

    getControlName = (control: AbstractControl) => {
        var controlName = null;
        var parent = control["_parent"];

        // only such parent, which is FormGroup, has a dictionary
        // with control-names as a key and a form-control as a value
        if (parent instanceof FormGroup) {
            // now we will iterate those keys (i.e. names of controls)
            Object.keys(parent.controls).forEach((name) => {
                // and compare the passed control and
                // a child control of a parent - with provided name (we iterate them all)
                if (control === parent.controls[name]) {
                    // both are same: control passed to Validator
                    //  and this child - are the same references
                    controlName = name;
                }
            });
        }
        // we either found a name or simply return null
        return controlName;
    }

    getObjectDifference(a,b){
        //Object.fromEntries(Object.entries(b).filter(([key, val]) => key in a && a[key] !== val)); !ignoreAttributeList.includes(k)
          if (a != null && b != null) {
              let difference = Object.entries(a).reduce((ac, [k, v]) => (b[k] && b[k] !== v && (k != 'updatedDt' && k != 'updatedUser')) ? (ac[k] = b[k], ac) : ac, {});
              return difference
          } 
        //   else if (a != null || b != null) {
        //       let difference = Object.entries(a).reduce((ac, [k, v]) => (b[k] && b[k] !== v && (k != 'updatedDt' && k != 'updatedUser')) ? (ac[k] = b[k], ac) : ac, {});
        //       return difference
        //   }
          else
              return {}
        

        
            /*const result = {};
            if (Object.is(obj1, obj2)) {
                return undefined;
            }
            if (!obj2 || typeof obj2 !== 'object') {
                return obj2;
            }
            Object.keys(obj1 || {}).concat(Object.keys(obj2 || {})).forEach(key => {
                if(obj2[key] !== obj1[key] && !Object.is(obj1[key], obj2[key])) {
                    result[key] = obj2[key];
                }
                if(typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
                    const value = this.getObjectDifference(obj1[key], obj2[key]);
                    if (value !== undefined) {
                        result[key] = value;
                    }
                }
            });
            return result; */
        
      }

      
    sortObject(sortKey, list, orderby) {
        if (this.isArrayIterable(list)) {
            return list.sort(this.compareValues(sortKey, orderby))
        }
        else {
            return list
        }
    }

    sortDateObject(k, o, orderby) {
        if (this.isArrayIterable(o))
            return o.sort(this.compareDateValues(k, orderby))
        else {
            return o
        }
    }

    isArrayIterable(data) {
        if (data && Array.isArray(data) && data.length > 0)
            return true
        else
            return false
    }

    getDO(IO) {
        let DOName
        if (IO) {
            DOName = this.getDOName(IO)
            if (DOName)
                return IO[DOName]
            else
                console.log(`BaseDO in received IO is unsupported`, IO)
        }
    }

    /** Assumption: There is only one key in IO as BaseDO */
    getDOName(IO) {
        if (IO) {
            for (const key in IO) {
                if (key.endsWith('DO') &&
                    this.appMetadataHandler.supportedBaseDOs.includes(key) &&
                    IO[key]) {
                    return key
                }
            }
        }
        else {
            console.error(`Received IO is invalid`, IO)
        }
    }

    /** Assumption: There is only one key in RoleNode on IO */
    getRoleNodeName(IO) {
        let DO = this.getDO(IO)
        if (DO) {
            for (const key in DO) {
                if ((key.endsWith('List') || key.endsWith('Roles') || key.endsWith('Clients')) &&
                    this.appMetadataHandler.supportedRoleNodes.includes(key) &&
                    DO[key]) {
                    return key
                    }
                // }else if(this.appMetadataHandler.supportedRoleNodes.includes(key) &&
                // DO[key]){
                //     return key
                // }
            }
        }
        else {
            console.error(`Could not extract DO from received IO`, IO)
        }
    }

    getRoleNode(IO) {
        let nodeName = this.getRoleNodeName(IO)
        let DO = this.getDO(IO);
        if (DO && nodeName)
            return DO[nodeName];
        else {
            console.error(`Unsupported RoleNode or DO found in received IO`, IO)
        }
    }



    compareValues(key, order) {
        return function (a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }

            const varA = (typeof a[key] === 'string') ?
                a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ?
                b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order == 'desc') ? (comparison * -1) : comparison
            );
        };
    }

    compareDateValues(key, order) {
        return function (a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }
            const varA = moment((typeof a[key] === 'string') ?
                a[key].toUpperCase() : a[key], ['DD-MM-YYYY', 'x']);
            const varB = moment((typeof b[key] === 'string') ?
                b[key].toUpperCase() : b[key], ['DD-MM-YYYY', 'x']);

            let comparison = 0;
            /*
            moment('2010-10-20').isBefore('2010-12-31', 'year'); // false
            moment('2010-10-20').isBefore('2011-01-01', 'year'); // true

            moment('2010-10-20').isAfter('2010-01-01', 'year'); // false
            moment('2010-10-20').isAfter('2009-12-31', 'year'); // true
            */

            if (varA.isAfter(varB)) {
                comparison = 1;
            } else if (varB.isAfter(varA)) {
                comparison = -1;
            }
            return (
                (order == 'desc') ? (comparison * -1) : comparison
            );
        };
    }

    markAllFieldDirty(form) {
        if (form && form.controls && Array.isArray(form.controls)) {
            for (const i in form.controls) {
                form.controls[i].markAsDirty();
                form.controls[i].updateValueAndValidity();
            }
        }
    }

    initializeLookupList(lookupList, metaData?) {
        var returnItem = {}
        if (lookupList && lookupList.length > 0) {
            lookupList.forEach(lookup => {
                let filteredMetaData= metaData ? metaData.filter(item => item.lookupCd == lookup) : null;
                let filteredLookupCSV = this.isArrayIterable(filteredMetaData) ? filteredMetaData.find(e => true).allowedLookUpCdCSV ? filteredMetaData.find(e => true).allowedLookUpCdCSV.split(',') : null : null;
                returnItem[lookup] = this.lookupDataService.getLookup(lookup,false, filteredLookupCSV);
            })
        }

        return returnItem
    }

    serverDOtoUIDODate(date) {
        let output = null
        if (date && Array.isArray(date)) {
            output = new Date(date[0], date[1] - 1, date[2])
        }
        else if (date) {
            output = new Date(date)
        }
        return output
    }


    serverDOtoUIDOsetTimeOLd(time) {
        let output = null
        if (time && Array.isArray(time)) {
            if (time.length > 4 || time.length === 4)
                output = new Date().setHours(time[0] || 0, time[1] || 0, time[2] || 0, time[3] || 0)
            else if (time.length === 3)
                output = new Date().setHours(time[0] || 0, time[1] || 0, time[2] || 0, 0)
            else if (time.length === 2)
                output = new Date().setHours(time[0] || 0, time[1] || 0, 0, 0)
            else if (time.length === 1)
                output = new Date().setHours(time[0], 0, 0, 0)
            else
                output = null
        }
        else if (time) {
            output = new Date(time)
        }
        return output
    }


    serverDOtoUIDOsetTime(time) {
        let output = null
        if (time && Array.isArray(time)) {
            if (time.length > 4 || time.length === 4) {
                output = new Date()
                output.setHours(time[0] || 0)
                output.setMinutes(time[1] || 0)
                output.setSeconds(time[2] || 0)
            }

            else if (time.length === 3) {
                output = new Date()
                output.setHours(time[0] || 0)
                output.setMinutes(time[1] || 0)
                output.setSeconds(time[2] || 0)
            }
            else if (time.length === 2) {
                output = new Date()
                output.setHours(time[0] || 0)
                output.setMinutes(time[1] || 0)
                output.setSeconds(0)
            }
            else if (time.length === 1) {
                output = new Date()
                output.setHours(time[0] || 0)
                output.setMinutes(0)
                output.setSeconds(0)
            }
            else
                output = null
        }
        else if (time) {
            output = new Date(time)
        }
        return output
    }

    UIDOtoServerDODate(date) {
        let output = null
        if (date != null) {
            date = new Date(date)
            output = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
        }
        return output
    }

    LocalDateTimeToLocalDate(date) {
        let output = null
        if (date && Array.toString) {
            output = [date[0], date[1], date[2]]
        }
        return output
    }

    UIDOtoServerDODateTime(date) {
        let output = null
        if (date != null) {
            date = new Date(date)
            output = [date.getFullYear(), date.getMonth() + 1, date.getDate(),0,0,0]
        }
        return output
    }

    UIDOtoServerDOsetTime(time: Date) {
        let output = null
        if (time) {
            time = new Date(time)
            if (time != null) {
                output = [time.getHours() || 0, time.getMinutes() || 0, time.getSeconds() || 0, 0]
            }
        }
        return output
    }

    getDurationTillPrecisionDays(localDate, type) {
        let normalDate = this.serverDOtoUIDODate(localDate)
        let dateMoment = moment(normalDate)
        if (localDate && dateMoment.isValid()) {
            let todayMoment = moment()
            let years = todayMoment.diff(dateMoment, 'year');
            dateMoment.add(years, 'years');
            let months = todayMoment.diff(dateMoment, 'months');
            dateMoment.add(months, 'months');
            let days = todayMoment.diff(dateMoment, 'days');
            if (years > -1 && months > -1 && days > -1) {
                if (type == 'object')
                    return { years: years, months: months, days: days }
                else if (type == 'string')
                    return (years + ' Years ' + months + ' Months ' + days + ' Days')
            }
            else {
                return null
            }
        }

    }

    humanizeNumberOfDays(total_days) {
        //var total_days = 1001;
        var date_current: any = new Date();
        var utime_target: any = date_current.getTime() + total_days * 86400 * 1000;
        var date_target: any = new Date(utime_target);

        var diff_year: any = parseInt((date_target.getUTCFullYear() - date_current.getUTCFullYear()).toString());
        var diff_month: any = parseInt((date_target.getUTCMonth() - date_current.getUTCMonth()).toString());
        var diff_day: any = parseInt((date_target.getUTCDate() - date_current.getUTCDate()).toString());

        var days_in_month = [31, (date_target.getUTCFullYear() % 4 ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var date_string = "";
        while (true) {
            date_string = "";
            date_string += (diff_year > 0 ? diff_year + "Years" : "");

            if (diff_month < 0) { diff_year -= 1; diff_month += 12; continue; }
            date_string += (diff_month > 0 ? diff_month + "Months" : "");

            if (diff_day < 0) { diff_month -= 1; diff_day += days_in_month[((11 + date_target.getUTCMonth()) % 12)]; continue; }
            date_string += (diff_day > 0 ? diff_day + "Days" : "");
            break;
        }
        console.log(date_string);
        return date_string;
    }

    getPersonOrgId(response) {
        if (response.clientDO.clientTypeCd === 'PERSON') {
            return response.clientDO.personDO.id
        }
        else if (response.clientDO.clientTypeCd === 'ORGANIZATION') {
            return response.clientDO.organisationDO.id
        }
    }

    getFirstOccupationCd(clientDO) {
        if (clientDO.clientTypeCd === 'PERSON') {
            if (this.isArrayIterable(clientDO.personDO.personEmploymentList)) {
                let firstItem = clientDO.personDO.personEmploymentList.find(personEmplList => true)
                return firstItem ? firstItem['occupationCd'] : null
            }
        }
    }

    convertCSVToArray(data) {
        if (data && typeof data == 'string')
            return data.split(',');
        else
            return []
    }

    convertArrayToCSV(data) {
        if (this.isArrayIterable(data))
            return data.join(',');
        else
            return null
    }

    extractClientDOFromProposalIO(proposalIO, extractRoleCd) {
        let filterOutput = []
        if (proposalIO &&
            proposalIO['proposalDO'] &&
            proposalIO['proposalDO']['proposalClients'] &&
            Array.isArray(proposalIO['proposalDO']['proposalClients']) &&
            proposalIO['proposalDO']['proposalClients'].length > 0) {
            let ownerRefGuid = proposalIO['proposalDO']['proposalClients'].find(item => {
                if (item)
                    return item['roleCd'] === extractRoleCd;
            }) || []

            filterOutput = proposalIO['clientDOs'].filter(item => {
                if (item)
                    return item['guid'] === ownerRefGuid.clientRefGuid;
            }) || []
        }
        return filterOutput
    }

    extractClientDOFromIOGeneric(IO, extractRoleCd) {
        let filterOutput = []
        let DO = this.getDO(IO)
        let roleNode = DO['proposalClients'] || DO['claimClientRoles'] || DO['caseClients']
        if (DO &&
            roleNode &&
            Array.isArray(roleNode) &&
            roleNode.length > 0) {
            let clientRole = roleNode.find(item => {
                if (item)
                    return item['roleCd'] === extractRoleCd;
            }) || []

            if (IO['clientDOs'] && Array.isArray(IO['clientDOs']))
                filterOutput = IO['clientDOs'].filter(item => {
                    if (item)
                        return item['guid'] === clientRole.clientRefGuid;
                }) || []
        }
        return filterOutput
    }

    extractClientDOListFromIOGeneric(IO, extractRoleCd) {
        let filterOutput = []
        let DO = this.getDO(IO)
        let roleNode = this.getRoleNodeName(IO);
        if (DO &&
            roleNode &&
            Array.isArray(DO[roleNode]) &&
            DO[roleNode].length > 0) {
            let clientRoleList = DO[roleNode].filter(item => {
                if (item)
                    return item['roleCd'] === extractRoleCd;
            }) || []

            if (IO['clientDOs'] && Array.isArray(IO['clientDOs']) && this.isArrayIterable(clientRoleList))
                clientRoleList.forEach(clientRole => {
                    let filteredClientDO = IO['clientDOs'].find(item => {
                        if (item)
                            return item['guid'] === clientRole.clientRefGuid;
                    }) || null

                    if (filteredClientDO)
                        filterOutput.push(filteredClientDO)
                })

        }
        return filterOutput
    }

    mapperToCreateClientList(fetchedClientData) {

        let output = [];

        if (fetchedClientData) {
            fetchedClientData.forEach(fetchedClientDO => {

                let selectedClientDO = this.selectedClientDOFromFetchedClientDO(fetchedClientDO)

                output.push(this.deepCopy(selectedClientDO))

            });
        }
        return output

    }

    mapperToCreateAgentList(fetchedClientData) {

        let output = [];

        if (fetchedClientData) {
            fetchedClientData.forEach(fetchedClientDO => {

                let selectedClientDO = this.selectedClientDOFromFetchedAgentsClientDO(fetchedClientDO)

                output.push(this.deepCopy(selectedClientDO))

            });
        }
        return output

    }

    selectedClientDOFromFetchedClientDO(fetchedClientDO) {
        let clientListItemDO = {
            clientNum: null,
            firstName: null,
            lastName: null,
            dateOfBirth: null,
            contactNum: null,
            emailId: null,
            id: null,
            guid: null,
            genderCd: null,
            companyName: null,
            contactPersonName: null,
            clientTypeCd: null,
            nomineeSplitPrct: 0,
            relationCd: null
        }
        if (fetchedClientDO) {
            let c = this.deepCopy(clientListItemDO)
            c.clientNum = fetchedClientDO['clientNum']
            c.contactNum = this.getPrefferedContactFromClient(fetchedClientDO)
            c.emailId = this.getPrefferedEmailFromClient(fetchedClientDO)
            c.id = fetchedClientDO['id']
            c.guid = fetchedClientDO['guid']
            c.clientTypeCd = fetchedClientDO['clientTypeCd']
            c.nomineeSplitPrct = fetchedClientDO['nomineeSplitPrct'] || 0
            c.relationCd = fetchedClientDO['relationCd'];
            if (fetchedClientDO.clientTypeCd === 'PERSON') {
                c.firstName = this.getFirstNameFromClient(fetchedClientDO)
                c.lastName = this.getLastNameFromClient(fetchedClientDO)
                c.dateOfBirth = this.getDateOfBirthFromClient(fetchedClientDO)
                c.genderCd = this.getGenderFromClient(fetchedClientDO)
                //c.relationCd = fetchedClientDO.personDO.relationCd;
            }
            else if (fetchedClientDO.clientTypeCd === 'ORGANIZATION') {
                c.companyName = this.getOrgCompanyNameFromClient(fetchedClientDO)
                c.contactPersonName = this.getContactPersonNameFromClient(fetchedClientDO)
            }

            return this.deepCopy(c)
        }
    }

    selectedClientDOFromFetchedAgentsClientDO(fetchedClientDO) {
        let agentListItemDO = {
            agentNum: null,
            firstName: null,
            lastName: null,
            channel: null,
            commissionPercent: 0,
            primaryFl: false,
            clientId: null,
            clientRefGuid: null,
        }
        if (fetchedClientDO) {
            let c = this.deepCopy(agentListItemDO)
            c.agentNum = fetchedClientDO.agentDO ? fetchedClientDO.agentDO['agentNum'] : '-';
            c.channel = fetchedClientDO.agentDO ? fetchedClientDO.agentDO['channelCd'] : '-';
            c.primaryFl = fetchedClientDO.agentDO ? fetchedClientDO.agentDO['primaryFl'] : false;
            c.commissionPercent = fetchedClientDO.agentDO ? fetchedClientDO.agentDO['commissionPercent'] : 0;
            if (c.commissionPercent === undefined)
                c.commissionPercent = 0;
            if (c.primaryFl === undefined)
                c.primaryFl = false;
            c.clientId = fetchedClientDO.clientDO ? fetchedClientDO.clientDO['id'] : null;
            c.clientRefGuid = fetchedClientDO.clientDO ? fetchedClientDO.clientDO['guid'] : null;
            if (fetchedClientDO.clientDO && fetchedClientDO.clientDO.clientTypeCd === 'PERSON') {
                c.firstName = this.getFirstNameFromClient(fetchedClientDO.clientDO)
                c.lastName = this.getLastNameFromClient(fetchedClientDO.clientDO)
                // c.dateOfBirth = this.getDateOfBirthFromClient(fetchedClientDO.clientDO)
                // c.genderCd = this.getGenderFromClient(fetchedClientDO.clientDO)
            }
            else if (fetchedClientDO.clientDO && fetchedClientDO.clientDO.clientTypeCd === 'ORGANIZATION') {
                c.firstName = this.getOrgCompanyNameFromClient(fetchedClientDO.clientDO)
            }

            return this.deepCopy(c)
        }
    }
    getPrefferedContactFromClient(client) {
        if (client.clientContactDetailsList) {
            let contactDetails = client.clientContactDetailsList.find(contact => contact.prefferedFl)
            if (contactDetails) {
                return contactDetails.contactNum;
            }
            else {
                return null
            }
        }
        else {
            return null
        }

    }

    getPrefferedEmailFromClient(client) {
        if (client.clientEmailList) {
            let emailDetails = client.clientEmailList.find(email => email.prefferedFl)
            if (emailDetails) {
                return emailDetails.emailId;
            }
            else {
                return null;
            }
        }
        else {
            return null
        }

    }

    getPrefferedAddresFromClient(client) {
        if (client.clientAddressList) {
            let addressDetails = client.clientAddressList.find(address => address.prefferedFl)
            if (addressDetails) {
                return addressDetails;
            }
            else {
                return [];
            }
        }
        else {
            return []
        }
    }

    getFirstName(response) {
        if (response && response.clientDO && response.clientDO.clientTypeCd === 'PERSON' && response.clientDO.personDO) {
            return response.clientDO.personDO.firstName
        }
        else {
            return null
        }
    }

    getFirstNameFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO) {
            return client.personDO.firstName
        }
        else {
            return null
        }
    }

    getLastName(response) {
        if (response && response.clientDO && response.clientDO.clientTypeCd === 'PERSON' && response.clientDO.personDO) {
            return response.clientDO.personDO.lastName
        }
        else {
            return null
        }
    }

    getLastNameFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO) {
            return client.personDO.lastName
        }
        else {
            return null
        }
    }

    getCountryOfBirthFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO) {
            return client.personDO.countryOfBirthCd
        }
        else {
            return null
        }
    }

    getCitizenshipFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO) {
            return client.personDO.citizenshipCd
        }
        else {
            return null
        }
    }

    getPersonIdentityListFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO) {
            return client.personDO.personIdentityList
        }
        else {
            return []
        }
    }

    getAddressListFromClient(client) {
        if (client && client.clientAddressList) {
            return client.clientAddressList
        }
        else {
            return []
        }
    }

    getOrgCompanyName(response) {
        if (response && response.clientDO && response.clientDO.clientTypeCd === 'ORGANIZATION' && response.clientDO.organisationDO) {
            return response.clientDO.organisationDO.companyName
        }
        else {
            return null
        }
    }

    getOrgCompanyNameFromClient(client) {
        if (client.clientTypeCd === 'ORGANIZATION' && client.organisationDO) {
            return client.organisationDO.companyName
        }
        else {
            return null
        }
    }

    getContactPersonNameFromClient(client) {
        if (client.clientTypeCd === 'ORGANIZATION' || client.clientTypeCd === 'ORGANISATION' && client.organisationDO) {
            return client.organisationDO.contactPersonName
        }
        else {
            return null
        }
    }

    getOrgContactPerson(response) {
        if (response && response.clientDO && response.clientDO.clientTypeCd === 'ORGANIZATION' && response.clientDO.organisationDO) {
            return response.clientDO.organisationDO.contactPersonName
        }
        else {
            return null
        }
    }

    getPersonOrgGuid(response) {
        if (response.clientDO.clientTypeCd === 'PERSON') {
            return response.clientDO.personDO.guid
        }
        else if (response.clientDO.clientTypeCd === 'ORGANIZATION') {
            return response.clientDO.organisationDO.guid
        }
    }

    getPersonOrgGuidFromClient(response) {
        if (response.clientTypeCd == 'PERSON') {
            return response.personDO.guid
        }
        else if (response.clientTypeCd == 'ORGANIZATION') {
            return response.organisationDO.guid
        }
    }

    getDateOfBirthFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO) {
            return client.personDO.dateOfBirth
        }
        else {
            return null
        }
    }

    getGenderFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO) {
            return client.personDO.genderCd
        }
        else {
            return null
        }
    }

    payeeList: any = [];
    onChangeForPayer(data: { guid: any; }, clientDO: any, event: boolean) {
        //this.deselectOtherClients(data, 'isPayee');
        let payerListSubject$: any = new BehaviorSubject(null);

        if (event) {
            // let paymentDo = new ClaimPaymentDO()
            let paymentDo = {}
            paymentDo['clientRefGuid'] = data.guid;
            paymentDo['clientDO'] = clientDO
            let indexFound = this.payeeList.findIndex(item => {
                if (item)
                    return item['clientRefGuid'] === data.guid;
            })
            if (indexFound === -1) {
                this.payeeList.push(paymentDo)
            }
            else {
                this.payeeList[indexFound]['clientDO'] = clientDO
            }
        }
        else {

            let output = this.payeeList.filter(item => {
                if (item)
                    return item['clientRefGuid'] !== data.guid;
            }) || []

            this.payeeList = output;
        }

        payerListSubject$.next(this.payeeList);

        return payerListSubject$
    }


    // sendPayerListToBankDetails(payeeList?) {
    //     this.payerListSubject$.next(payeeList);
    // }
    getContactNumFromClient(client) {
        if (client && client.clientContactDetailsList && Array.isArray(client.clientContactDetailsList) && client.clientContactDetailsList.length > 0) {
            let preferred = client.clientContactDetailsList.find(contactDetails => contactDetails.prefferedFl)
            if (preferred) {
                return preferred.contactNum
            }
            else {
                let notMarkedPreferred = client.clientContactDetailsList.find(contactDetails => true)
                return notMarkedPreferred.contactNum
            }
        }
        else {
            return null
        }
    }

    getEmailFromClient(client) {
        if (client && client.clientEmailList && Array.isArray(client.clientEmailList) && client.clientEmailList.length > 0) {
            let preferred = client.clientEmailList.find(emailDetails => emailDetails.prefferedFl)
            if (preferred) {
                return preferred.emailId
            }
            else {
                let notMarkedPreferred = client.clientEmailList.find(emailDetails => true)
                return notMarkedPreferred.emailId
            }
        }
        else {
            return null
        }
    }

    public convertArrayToMap(list: any, keyAttribute: string): Object {
        let output = {};
        if (this.isArrayIterable(list)) {
            list.forEach(item => {
                if (item[keyAttribute])
                    output[item[keyAttribute]] = this.deepCopy(item);
                else
                    console.error(`|Array => Map| might not have been successful. Key attribute (${keyAttribute}) not found in list`, list);
            });
        }
        return output
    }

    public convertArrayToMapWithMultipleValues(list: any, keyAttribute: string): Object {
        let output = {};
        if (this.isArrayIterable(list)) {
            list.forEach(listItem => {
                if (output[listItem[keyAttribute]]) {
                    let oldValue = output[listItem[keyAttribute]]
                    let convertedToArray = [oldValue]
                    convertedToArray.push(this.deepCopy(listItem))
                    output[listItem[keyAttribute]] = this.deepCopy(listItem);
                }
                else {
                    output[listItem[keyAttribute]] = this.deepCopy(listItem);
                }
            });
        }

        return output
    }

    public convertMapToArray(map: Object): Array<any> {
        let output = [];
        for (const key in map) {
            output.push(this.deepCopy(map[key]))
        }
        return output
    }

    public convertMapToArrayWithoutDeepCopy(map: Object): Array<any> {
        let output = [];
        for (const key in map) {
            output.push(map[key])
        }
        return output
    }

    public mergeTwoListOfObjects(objectGettingOverridden: Array<any>, objectToOverride: Array<any>, compareKey: string, sortKey?: any, sortAscDesc?: string) {

        let merge = (a, b, p) => a.filter(aa => !b.find(bb => aa[p] === bb[p])).concat(b);
        let output = merge(objectGettingOverridden, objectToOverride, compareKey)
        if (sortKey)
            output = this.sortObject(sortKey, output, (sortAscDesc || 'asc'))

        return output
    }

    public recursiveKeySearch(key, data, objectName?, queryAttribute?, queryValue?, parentData?, parentQueryAttribute?, parentQueryValue?) {
        // not shown - perhaps validate key as non-zero length string

        // Handle null edge case.
        if (data === null) {
            // nothing to do here
            return [];
        }

        // handle case of non-object, which will not be searched
        if (data !== Object(data)) {
            return [];
        }

        var results = [];

        // Handle array which we just traverse and recurse.
        if (data.constructor === Array) {
            for (var i = 0, len = data.length; i < len; i++) {
                results = results.concat(this.recursiveKeySearch(key, data[i], objectName, queryAttribute, queryValue, data, parentQueryAttribute, parentQueryValue));
            }
            return results;
        }

        //If any criteria is passed, we would have to evaluate it.
        let criteria;
        if (objectName && queryAttribute && queryValue) {
            criteria = (data.objectName == objectName && data[queryAttribute] == queryValue)
        }
        else if (objectName && parentData && parentQueryAttribute && parentQueryValue) {
            criteria = data.objectName == objectName && parentData[parentQueryAttribute] == parentQueryValue
        }

        // We know we have an general object to work with now.
        // Now we need to iterate keys
        for (var dataKey in data) {
            if (key === dataKey && criteria) {
                // we found a match
                let output = { foundData: data[key], dataChunk: data, objectName: data.objectName }
                output[key] = data[key]
                results.push(this.deepCopy(output));
            }
            // now recurse into value at key
            results = results.concat(this.recursiveKeySearch(key, data[dataKey], objectName, queryAttribute, queryValue, data, parentQueryAttribute, parentQueryValue));
        }

        return results;
    }

    flattenObject(o, safety?, maxDepth?) {
        let safeValue = safety == 'unsafe' ? false : true
        let output = flat(o, {
            safe: safeValue,
            delimiter: '-',
            maxDepth: maxDepth
        })
        for (const key in output) {
            if (typeof output[key] != 'string' && Array.isArray(output[key])) {
                output[key].forEach(item => {
                    if (item)
                        item = this.flattenObject(item)
                });
            }
        }
        return output
    }

    plainflattenObject(o, safety?, maxDepth?) {
        let safeValue = safety == 'unsafe' ? false : true
        let output = flat(o, {
            safe: safeValue,
            delimiter: '-',
            maxDepth: maxDepth
        })
        return output
    }

    plainUnflattenObject(o, safety?, maxDepth?) {
        let safeValue = safety == 'unsafe' ? false : true
        let output = flat.unflatten(o, {
            safe: safeValue,
            delimiter: '-',
            maxDepth: maxDepth
        })
        return output
    }

    uniquePushInArray(list = [], item, uniqueKey?) {
        if (Array.isArray(list) && item) {
            if (uniqueKey) {
                let foundIndex = list.findIndex(e => e[uniqueKey] == item[uniqueKey])
                if (foundIndex != -1) {
                    list.splice(foundIndex, 1, item)
                }
                else {
                    list.push(item)
                }
            }
            else {
                if (!list.includes(item)) {
                    list.push(item)
                }
            }
        }

        return list
    }

    splitMulti(str, tokens = [], excludeTokens = []) {
        let presetTokens = ['/', ' ', '-', '(', ')', ',']
        if (Array.isArray(tokens)) {
            tokens.push(...presetTokens)
            if (Array.isArray(excludeTokens))
                tokens = tokens.filter(e => !excludeTokens.includes(e)) || []
        }
        var tempChar = tokens[0]; // We can use the first token as a temporary join character
        for (var i = 1; i < tokens.length; i++) {
            str = str.split(tokens[i]).join(tempChar);
        }
        str = str.split(tempChar);
        return str;
    }

    spellCheck(phrase) {
        let dictspell = new spelling(dict)
        let output = this.splitMulti(phrase)
        let wrongWords = [];
        let spellResultWrong
        let didYouMean = []
        if (Array.isArray(output)) {
            output.forEach(word => {
                if (!dictspell.lookup(word)['found']) {
                    wrongWords.push(word)
                    let suggestions = dictspell.lookup(word)['suggestions']
                    if (this.isArrayIterable(suggestions)) {
                        didYouMean = suggestions.map(a => a.word);
                    }
                }
            })
        }
        let returnObject = { wrongWords: wrongWords, wrongWordsString: `Spell Check for - ${wrongWords.join(', ')}`, didYouMean: didYouMean, toolTip: `Wrong Words - ${wrongWords.join(', ')} | Did you mean? - ${didYouMean.join(', ')}` }
        return returnObject
    }

    testJSON(text) {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        }
        catch (error) {
            return false;
        }
    }

    truncateBefore(str, pattern) {
        return str.slice(str.indexOf(pattern) + pattern.length);
    };

    truncateAfter(str, pattern) {
        return str.slice(0, str.indexOf(pattern));
    }

    setFieldMappingForAdditionalDOs(metaData: any, nestedIO: any, additionalAttributeValueKeyName) {

        if (metaData && Array.isArray(metaData)) {
            metaData.forEach((field, index) => {
                if (field.fieldMapping && field.fieldMapping.includes('$additionalDetails')) {
                    let attributes = this.splitMulti(field.fieldMapping, ['-']) || [];
                    let attributeCd = field.fieldKey;
                    let attributeKeyName = attributes.slice(-2);

                    let newBaseMapping = this.truncateAfter(field.fieldMapping, '$additionalDetails').replace('$', '0-');
                    let newMapping;
                    if (newBaseMapping && nestedIO && nestedIO[newBaseMapping] && Array.isArray(nestedIO[newBaseMapping])) {
                        let foundIndex = nestedIO[newBaseMapping].findIndex(element => element[attributeKeyName] == attributeCd);
                        if (foundIndex != -1) {
                            newMapping = `${newBaseMapping}-${foundIndex}-${additionalAttributeValueKeyName}`;
                        }
                        else {
                            let newIndex = nestedIO[newBaseMapping].length;
                            newMapping = `${newBaseMapping}-${newIndex}-${additionalAttributeValueKeyName}`;
                        }
                    }

                    if (newMapping) {
                        metaData[index]['oldFieldMapping'] = field.fieldMapping;
                        field.fieldMapping = newMapping;
                        metaData[index]['fieldMapping'] = newMapping;
                        metaData[index]['attributeKeyName'] = attributeKeyName
                        metaData[index]['isAdditionalDO'] = true
                        metaData[index]['additionalAttributeValueKeyName'] = additionalAttributeValueKeyName

                    }

                }
            })
        }

        return metaData
    }

    addLookupDataToCache(key, value, lookupCd) {
        this.lookupDataService.addLookupDataToCache(key, value, lookupCd);
    }

    addLookupListToCache(list, lookupCd) {
        this.lookupDataService.addLookupListToCache(list, lookupCd)
    }

    setLookupListToCache(list, lookupCd) {
        this.lookupDataService.setLookupListToCache(list, lookupCd)
    }
    areTheArraysEqual(list1, list2) {
        return _(list1).xorWith(list2, _.isEqual).isEmpty();
    }

    deepMergeObjects(originalObject, updatedObject, uniqueKey) {
        return _.values(_.merge(
            _.keyBy(originalObject, uniqueKey),
            _.keyBy(updatedObject, uniqueKey)
        ));
    }

    generateRandom(maxLimit = 100, roundOff = true){
        let rand:any = (Math.random() * maxLimit);  
        if(roundOff){
            rand = Math.floor(rand); 
        }else{
            rand = rand.toFixed(2);
        }
        return rand;
    }
    generateAndDownloadPDF(templateID, fileName, orientation , unit){
        let data = document.getElementById(templateID);
        html2canvas(data).then(canvas => {
            const contentDataURL = canvas.toDataURL('image/png')  
            let doc = new jsPDF(orientation || 'l', unit ||'cm', 'a4'); //Generates PDF in landscape mode
            doc.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);  
            doc.save(fileName+".pdf");
          });
         
    }

    
    getMonthName() {
        let monthNumber = (new Date).getMonth()
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return months[monthNumber];
    }

    angularVersion() {
        let angularVersion = VERSION.full;
        // Parse the major version of Angular
        const majorVersion = parseInt(angularVersion.split('.')[0], 10);
        return majorVersion;
    }
    skipSubstring(str,substring) {
        var regex = new RegExp(substring, "gi");
        str = str.replace(regex, "");
        return str;
    }

    getNameFromClient(clientDO) {
        if (clientDO && clientDO.clientTypeCd === 'PERSON' && clientDO.personDO) {
            return clientDO.personDO.firstName +" "+ clientDO.personDO.lastName
        }
        else {
            return null
        }
    }

    formatDateToDDMMYYYY(date){
        // const today = new Date();
        let formattedToday = null;
        if(date){
           const yyyy = date.getFullYear();
            let mm = date.getMonth() + 1; // Months start at 0!
            let dd = date.getDate();
    
            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;
    
            formattedToday = dd + '/' + mm + '/' + yyyy; 
        }
        return formattedToday
    }
    
    getBenefitAmountFromDO(DO){
        let claimSettelmentObj: any
        if(DO && DO.claimSettlement && Array.isArray(DO.claimSettlement)){
            claimSettelmentObj = DO.claimSettelmentObj.find(e=>true)
            if(claimSettelmentObj && claimSettelmentObj.benefitAmt)
                return claimSettelmentObj.benefitAmt
            else return 0
        } else return 0
    }

    getOccupationFromClient(client) {
        if (client.clientTypeCd === 'PERSON' && client.personDO && client.personDO.personEmploymentList) {
            let personEmployment = client.personDO.personEmploymentList.find(employmentDetails => true)
            if(personEmployment && personEmployment.occupationCd)
                return personEmployment.occupationCd
            else null
        }
        else {
            return null
        }
    }

    getIncomeFromClient(client) {
        let returnObj = null;
        if (client.clientTypeCd === 'PERSON' && client.personDO && client.personDO.personEmploymentList) {
            let personEmploymentDetails = client.personDO.personEmploymentList.find(employmentDetails => true)
            if(personEmploymentDetails && personEmploymentDetails.montlyIncome)
            returnObj =  personEmploymentDetails.montlyIncome
            else returnObj = 0
        }
        else {
            return returnObj = 0
        }
        return returnObj;
    }


    replaceNumberWithEmptyString(value){
        if (value) {
            value = value.replace(/\d+/g, "")
        }
        return value
    }

    extractSmartUIConfig(smartUIConfig){
        if(smartUIConfig && smartUIConfig.configDO){
          return smartUIConfig.configDO;
        }
        return {};
      }
      month:any;
      days:any;
      age:any;
      int:any;
      decDays:any;
      humanizeNumberOfMonths(total_days) {
          var date_string = "";
          this.month = total_days * 0.032855;
          this.int = Math.floor(this.month)
          this.age = this.month - this.int;
          this.days =  this.age / 0.032855;
          if(this.age>=0.5){
            this.decDays =  Math.round(this.days)
          }
          else{
            this.decDays = Math.floor(this.days)
          }
  
          date_string = this.int + " months " + this.decDays + " days"  
          // console.log("ramesh",date_string);
          return date_string;
      }

    sortObjectWithNullValues(k, o, orderby) {
        return o.sort(this.compareValuesWithNullValues(k, orderby))
    }

    compareValuesWithNullValues(key, order) {
        return function (a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }
            const varA = (typeof a[key] === 'string') ?
                a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ?
                b[key].toUpperCase() : b[key];
            // Check for null values
            if (varA === null && varB !== null) {
                return 1; // push null values to the end
            } else if (varA !== null && varB === null) {
                return -1; // keep non-null values before null values
            } else if (varA === null && varB === null) {
                return 0; // both are null
            }

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order == 'desc') ? (comparison * -1) : comparison
            );
        };
    }
}

@Injectable()
export class GuidGenerator {
    private guid: String = null

    public getGuid(): String {
        return this.guid;
    }

    public setGuid() {
        var guid = ''
        guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        this.guid = guid;
        return this.guid
    }

}

@Injectable()
export class Lookup {
    public lookupCd: String = null;

    constructor(private lookupdataService: LookupDataService) {

    }

    getLookups(lookupCdArray): Observable<any> {
        let lookupDataList = [];
        lookupDataList = lookupCdArray;
        let lookupDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want
        if (lookupCdArray instanceof Array) {
            let returnObj = {};
            this.lookupdataService.getLookup(lookupCdArray[0])
                .subscribe(jsonResp => {
                    console.log(jsonResp)
                    console.log(JSON.stringify(jsonResp));
                    returnObj = jsonResp;
                    console.log(returnObj);
                    lookupDataSubject.next(returnObj);
                    //policySearchData.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
                });
            // return returnObj;

        }
        return lookupDataSubject
    }

    changeDynamicFormConfiguration(apiData,formName){
        // /api/productMetadata/fetchBasePlanMetadata/{productId}

    }


}
